import { Subject, from, EMPTY } from 'rxjs';
import { catchError, distinct, mergeMap, scan, share } from 'rxjs/operators';
const loadedFonts$ = new Subject();
/**
 * Returns a Subject of key-value pairs where the key is a font family name,
 * and the value is the number of times a font file for that family has been loaded.
 * Application fonts should be defined on document.fonts before loadFonts is called.
 */
export function loadFonts() {
    var _a;
    // Register all document fonts. Assumes registering duplicates is harmless and inexpensive.
    (_a = document.fonts) === null || _a === void 0 ? void 0 : _a.forEach(registerFontFace);
    return loadedFonts$;
}
/**
 * Registers a FontFace object with FontProvider and document.fonts
 */
export function registerFontFace(fontFace) {
    registeredFonts$.next(fontFace);
}
const registeredFonts$ = new Subject();
const uniqueFonts$ = registeredFonts$.pipe(
// Avoid adding the same font multiple times
distinct((font) => getFontKey(font)), share());
/**
 * Add fonts to document.fonts as they are registered
 */
uniqueFonts$.subscribe((fontFace) => {
    try {
        document.fonts.add(fontFace);
    }
    catch (e) {
        // @font-face declaration may already exist
    }
});
/**
 * Emit custom FontFaces as they are loaded.
 */
uniqueFonts$
    .pipe(mergeMap((fontFace) => {
    return from(fontFace.loaded).pipe(catchError((err) => {
        console.error(`Failed to load font '${getFontKey(fontFace)}' with error: '${err}'`);
        return EMPTY; // Return a null observable to continue the stream
    }));
}), scan((loadedFonts, font) => {
    var _a;
    return Object.assign(Object.assign({}, loadedFonts), { [font.family]: ((_a = loadedFonts[font.family]) !== null && _a !== void 0 ? _a : 0) + 1 });
}, {}))
    .subscribe((value) => {
    loadedFonts$.next(value);
});
/**
 * Returns a string describing the given font. Used to deduplicate similar font definitions.
 */
function getFontKey({ family, weight, style }) {
    return `${style} ${weight} "${family}"`;
}
